var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.cmpIs,{tag:"component",class:_vm.btnClasses,attrs:{"to":_vm.to.name ? _vm.to : null,"href":_vm.href ? _vm.href : null,"disabled":_vm.disabled ? _vm.disabled : null},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }